import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    messages: null,
    unReadMessages: 0
}

const messagesSlice = createSlice({
    name: "messages",
    initialState,
    reducers: {
        initMessages(state, action) {
            state.messages = action.payload.messages;
            state.unReadMessages = action.payload.unReadMessages;
        },
        setUnReadMessages(state, action) {
            let newMessages = [...state.messages]
            newMessages.map(m => {
                if (!m.isRead) {
                    m.isRead = true
                }
            })
            state.messages = newMessages
            state.unReadMessages = action.payload;
        }
    }
})

export const messagesActions = messagesSlice.actions;
export default messagesSlice
